import { createSlice } from '@reduxjs/toolkit';

const configSlice = createSlice({
  name: 'config',
  initialState: {},
  reducers: {
    setConfig: (state, action) => action.payload
  },
});

export const { setConfig } = configSlice.actions;
export default configSlice.reducer;

// SELECTORS
export const selectConfig = (state) => state.config;
export const selectIsMapi = (state) => state.config?.project === "Mapi";

export const selectReportsEndpoint = (state) => state.config?.reportsEndPoint;
export const selectGeneralEndpoint = (state) => state.config?.generalEndPoint;
export const selectUsersEndpoint = (state) => state.config?.usersEndPoint;
export const selectSearchEndpoint = (state) => state.config?.searchEndPoint;
export const selectSocketEndpoint = (state) => state.config?.socketConnectionEndPoint;
